import React, { useEffect } from 'react';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import './quem_somos.css';
import { assets } from "../assets/assets";

const QuemSomos = () => {
  useEffect(() => {
    document.title = "Trinco | Quem somos";
  }, []);
  return (
    <>
      <Header />
      <div className="quem-somos-container">
        <div className="quem-somos-content">
          <h1 className="quem-somos-title">QUEM SOMOS</h1>

          <div className="quem-somos-grid">
            {/* Texto Institucional */}
            <div className="text-section">
              <p>
                A Trinco representa um legado que começou na década de 70 em Salvador. Ao longo de gerações, construímos uma história baseada em confiança, cuidado e excelência no atendimento.
              </p>
              <p>
                Com raízes familiares e uma tradição construída ao longo do tempo, a Trinco se consolidou como referência em soluções práticas e serviços especializados, unindo cuidado, técnica e tecnologia para atender às necessidades do dia a dia.
              </p>
              <p>
                Nossa rede é reconhecida pela diversidade e qualidade dos serviços que oferece. Em cada uma de nossas unidades, estrategicamente localizadas nos principais shoppings da capital baiana e região, você encontra uma equipe preparada para resolver desde os detalhes mais simples até os desafios mais complexos.
              </p>
              <p className="final-text">
                Tradição no serviço. Cuidado no atendimento.
              </p>
            </div>

            {/* Imagem Lateral da Equipe */}
            <div className="quem-somos-imagem-lateral">
              <img src={assets.equipeTrinco} alt="Equipe Trinco" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default QuemSomos;